import React from 'react'
import './brand.scss';
import './imports'
import { bitmap, dropbox, google, slack,shopify } from './imports';

const Brand = () => {
  return (
    <div className='gpt3__brands section__padding'>
      <div>
      <img src={google} alt="google" />
      </div>
      <div>
      <img src={slack} alt="slack" />
      </div>
      <div>
      <img src={bitmap} alt="bitmap" />
      </div>
      <div>
      <img src={dropbox} alt="dropbox" />
      </div>
      <div>
      <img src={shopify} alt="shopify" />
      </div>
      
    </div>
  )
}

export default Brand